import React from "react";
import {
  Box,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import propTypes from "prop-types";

const ViewDocumentModal = ({ name, isOpen, onClose, size = "6xl", url }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={size}>
      <ModalOverlay />

      <ModalContent>
        <ModalHeader>{name}</ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <Box as="iframe" height="78vh" src={url} width="100%" />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

ViewDocumentModal.propTypes = {
  isOpen: propTypes.bool.isRequired,
  name: propTypes.string,
  onClose: propTypes.func.isRequired,
  size: propTypes.string,
  url: propTypes.string,
};

export default ViewDocumentModal;
